import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import React from "react";

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    console.log('Auth0 redirect callback - App State:', appState);
    // Ajoutez un délai pour s'assurer que le token est bien stocké
    setTimeout(() => {
      navigate(appState?.returnTo || window.location.pathname, { replace: true });
    }, 100);
  };

  if (!(domain && clientId)) {
    console.error('Configuration Auth0 manquante');
    return <div>Erreur de configuration</div>;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: "openid profile email",
      }}
      cacheLocation="localstorage"
      useRefreshTokens={false}
      useRefreshTokensFallback={false}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;